import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function createSumInsuredValidator(isMotorcycle: Boolean): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {

      const value = control.value;
      let amount: number = 500000;
      if (isMotorcycle) amount = 80000;

      if (!value || value.length < 6) {
          return null;
      }

      const numericValue = parseInt(value.replace(/\D/g,''));

      const isBelow500K: boolean = numericValue < amount;
      // const isAbove10M: boolean = numericValue > 10000000;

      // const valueValid = !isBelow500K && !isAbove10M;
      const valueValid = !isBelow500K;

      
      // return !valueValid && isBelow500K ? {cMin: isBelow500K} : !valueValid && isAbove10M ? {cMax: isAbove10M}: null;
      return !valueValid && isBelow500K ? {cMin: isBelow500K} : null;
  }
}

export function createAmountAbove30KValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;

        if (!value || value.length < 6) {
            return null;
        }

        const numericValue = parseInt(value.replace(/\D/g,''));

        const isBelow30K: boolean = numericValue <= 50000;
        const isAbove100k: boolean = numericValue > 1000000;

        const valueValid = !isBelow30K && !isAbove100k;

        
        return !valueValid && isBelow30K ? {cMin: isBelow30K} : !valueValid && isAbove100k ? {cMax: isAbove100k}: null;
    }
}

export function createTZLimitsValidator(type: string): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        let varis = {
            minimum: 1000000,
            maximum: 5000000,
            length: 7,
        };

        if (type === 'ent') {
            varis.minimum = 500000;
            varis.maximum = 1000000;
            varis.length = 6;
        }

        const value = control.value;

        if (!value || value.length < varis.length) {
            return null;
        }

        const numericValue = parseInt(value.replace(/\D/g,''));

        const isBelowMinimum: boolean = numericValue < varis.minimum;
        const isAboveMaximum: boolean = numericValue > varis.maximum;

        const valueValid = !isBelowMinimum && !isAboveMaximum;

        
        return !valueValid && isBelowMinimum ? {cMin: isBelowMinimum} : !valueValid && isAboveMaximum ? {cMax: isAboveMaximum}: null;
    }
}

export function createIAgreeValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;

        if (!value || value === true) {
            return null;
        }
        const valueInvalid: boolean = value === false;
        
        return valueInvalid ? {ticked: true} : null;
    }
}

export function createCurrencyLimitValidator(min: number = 50000, max: number = 1000000): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    const value = control.value;
    if (!value || value.length < 6) {
        return null;
    }

    const numericValue = parseInt(value.replace(/\D/g,''));
    const isBelow: boolean = numericValue <= min;
    const isAbove: boolean = numericValue > max;
    const valueValid = !isBelow && !isAbove;

    return !valueValid && isBelow ? {cMin: isBelow} : !valueValid && isAbove ? {cMax: isAbove}: null;
  }
}

